import state from './state'
import * as getters from './getters'
import * as actions from './actions'

export default {
  namespaced: true,
  state,
  getters,
  actions
}
